<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}<button type="button" class="close" @click.prevent="closeModal()"><span aria-hidden="true">&times;</span>
      </button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid">
        <div v-if="generalErrorMessage" class="row">
          <div class="col">
            <div class="alert alert-danger" role="alert">
              {{ generalErrorMessage }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-1"></div>
          <div class="col-8">
            <b-form-group :label-cols="5"
                          label="Description"
                          :state="stateForField('description')"
                          :invalid-feedback="errorForField('description')"
                          label-class="text-right"
                          class="mt-2">
              <b-form-input v-model="estimateFee.description"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="5"
                          label="Short Code"
                          :state="stateForField('shortCode')"
                          :invalid-feedback="errorForField('shortCode')"
                          label-class="text-right"
                          class="mt-2">
              <b-form-input v-model="estimateFee.shortCode"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="5" label="Fee Type" :state="stateForField('feeType')" :invalid-feedback="errorForField('feeType')" label-class="text-right">
              <b-select class="input-border" v-model="estimateFee.feeType" :options="feeTypeOptions">
              </b-select>
            </b-form-group>
            <span v-if="estimateFee && estimateFee.feeType === 'FlatAmount'">
            <b-form-group :label-cols="5" label="Amount" label-align="right" :state="stateForField('amount')" :invalid-feedback="errorForField('amount')">
              <b-input-group prepend="$">  <b-form-input v-model="estimateFee.amount"></b-form-input></b-input-group>
            </b-form-group>
              </span>
            <span v-else>
              <b-form-group :label-cols="5" label="Percent" label-align="right" :state="stateForField('amount')" :invalid-feedback="errorForField('amount')">
              <b-input-group append="%">  <b-form-input v-model="estimateFee.amount"></b-form-input></b-input-group>
            </b-form-group>
            </span>
            <b-form-group :label-cols="5" label="Covered Item" :state="stateForField('coveredItem')" :invalid-feedback="errorForField('coveredItem')" label-class="text-right">
              <b-form-radio-group class="input-border pt-2" v-model="estimateFee.coveredItem" :options="yesNoOptions"></b-form-radio-group>
            </b-form-group>
            <b-form-group :label-cols="5" label="Default" :state="stateForField('default')" :invalid-feedback="errorForField('default')" label-class="text-right">
              <b-form-radio-group class="input-border pt-2" v-model="estimateFee.appliedByDefault" :options="yesNoOptions"></b-form-radio-group>
            </b-form-group>
          </div>
      </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="saveEstimateFee()">Save</button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>
<script>

  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'
  import _ from 'lodash'

  export default {
    name: 'EstimateFeeModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      editEstimateFee: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        estimateFee: {},
        feeTypeOptions: [
          { value: null, text: 'Click to Select', disabled: true },
          { value: 'FlatAmount', text: 'Flat Amount' },
          { value: 'PercentageOfCodes', text: 'Percentage Of Codes' },
          { value: 'PercentageOfTotal', text: 'Percentage Of Total' }
        ],
        yesNoOptions: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ]
      }
    },

    computed: {
      title () {
        if (this.estimateFee && this.estimateFee.organizationEstimateFeeId) {
          return 'Edit Estimate Fee'
        }
        return 'Create Estimate Fee'
      }
    },

    watch: {
      editEstimateFee (newValue) {
        this.estimateFee = _.clone(newValue)
        if (this.estimateFee.feeType === 'PercentageOfCodes') {
          this.estimateFee.amount = this.estimateFee.amount * 100
        }
        if (this.estimateFee.feeType === 'PercentageOfTotal') {
          this.estimateFee.amount = this.estimateFee.amount * 100
        }
      }
    },

    methods: {
      validate () {
        this.clearAllErrors()

        if (!this.estimateFee.description) {
          this.addErrorForField('description', 'You must choose a description')
        }

        if (!this.estimateFee.feeType) {
          this.addErrorForField('feeType', 'You must choose a fee type')
        }

        if (!this.estimateFee.amount) {
          this.addErrorForField('amount', 'You must enter a number')
        }

        return !this.hasErrors()
      },
      closeModal () {
        this.$emit('update:visible', false)
      },

      saveEstimateFee () {
        if (this.isSaving) {
          return
        }
        if (!this.validate()) {
          return
        }
        this.clearAllErrors()
        const fee = _.assign({}, this.estimateFee)

        if (fee.feeType === 'PercentageOfCodes' || fee.feeType === 'PercentageOfTotal') {
          if (fee.amount > 1) {
            fee.amount = fee.amount / 100
          }
        }
        this.isSaving = true
        api.post('Dashboard/EstimateFee', fee).then(response => {
          this.isSaving = false
          this.$emit('updated', response)
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
          }
        })
      }
    }

  }
</script>
